module.exports = __webpack_public_path__ + "assets/108c5240ed7564acb2017adecdd8f1b8.png";